// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"110":"7e3c2a7f","631":"d7f85dfd"}[chunkId] + ".chunk.css";
};